import { DRAWING_COLORS } from './constants';

const C = DRAWING_COLORS;

/**
 * Print-ready scale verification bar (印刷時原寸確認用).
 * Renders a 100mm line in the sheet margin so the operator can verify
 * the drawing was printed at 1:1 scale.
 */
export function ScaleBar({ x, y }: { x: number; y: number }) {
  const barWidth = 100; // mm
  const tickH = 3;
  const fontSize = 2.2;

  return (
    <g className="scale-bar" transform={`translate(${x}, ${y})`}>
      {/* Main bar */}
      <line x1={0} y1={0} x2={barWidth} y2={0}
        stroke={C.line} strokeWidth={0.4} />
      {/* End ticks */}
      <line x1={0} y1={-tickH / 2} x2={0} y2={tickH / 2}
        stroke={C.line} strokeWidth={0.4} />
      <line x1={barWidth} y1={-tickH / 2} x2={barWidth} y2={tickH / 2}
        stroke={C.line} strokeWidth={0.4} />
      {/* Mid tick */}
      <line x1={barWidth / 2} y1={-tickH / 3} x2={barWidth / 2} y2={tickH / 3}
        stroke={C.line} strokeWidth={0.3} />
      {/* Label */}
      <text x={barWidth / 2} y={tickH / 2 + fontSize + 0.5}
        textAnchor="middle" dominantBaseline="auto"
        fontSize={fontSize} fontFamily="'Noto Sans JP', sans-serif" fill={C.text}>
        印刷時原寸確認用 100mm
      </text>
    </g>
  );
}
